import __vue_component__$d from '../../../components/ItineraryWaypoint/components/ItineraryWaypointConfirmDeparture.vue.js';
import __vue_component__$3 from '../../../components/ItineraryWaypoint/components/ItineraryWaypointFollowKitInstructions.vue.js';
import __vue_component__$a from '../../../components/ItineraryWaypoint/components/ItineraryWaypointPatientConsent.vue.js';
import __vue_component__$5 from '../../../components/ItineraryWaypoint/components/ItineraryWaypointPatientDOB.vue.js';
import __vue_component__$8 from '../../../components/ItineraryWaypoint/components/ItineraryWaypointSampleChecklist.vue.js';
import __vue_component__$2 from '../../../components/ItineraryWaypoint/components/ItineraryWaypointStartTransit.vue.js';
import __vue_component__$e from '../../../components/ItineraryWaypoint/components/ProcedureCharting/ChartingTubeLabelWarning.vue.js';
import __vue_component__$9 from '../../../components/ItineraryWaypoint/components/ProcedureCharting/ItineraryWaypointProcedureCharting.vue.js';
import __vue_component__$6 from '../../../components/ItineraryWaypoint/components/WorkflowItemScanner.vue.js';
import __vue_component__ from '../../../components/Workflow/components/InlineTransit.vue.js';
import __vue_component__$7 from '../../../components/Workflow/components/WorkflowEmbed.vue.js';
import __vue_component__$b from '../../../components/Workflow/DropOffDetails/LabOrder.vue.js';
import __vue_component__$4 from '../../../steps/patientWaypoint/ItineraryFlowNurseIdentity.vue.js';
import __vue_component__$c from '../../../steps/patientWaypoint/procedure/ItineraryFlowProcedureInstructions.vue.js';
import __vue_component__$1 from '../../../steps/patientWaypoint/procedure/subComponents/TestModalComp.vue.js';
import { WorkflowInlineComponentName, WorkflowModalComponentName, FooterOpenModalComponentName } from './model.js';

const WorkflowInlineComponentRecord = {
    /**
     * GoToPatient and StartTransit handle the waypoint transit management for
     * all waypoint types
     */
    [WorkflowInlineComponentName.GO_TO_PATIENT]: __vue_component__,
    [WorkflowInlineComponentName.SAMPLE_CHARTING]: __vue_component__$1,
    [WorkflowInlineComponentName.START_TRANSIT]: __vue_component__$2,
    [WorkflowInlineComponentName.TODO]: __vue_component__$1,
};
const WorkflowModalComponentRecord = {
    [WorkflowModalComponentName.FOLLOW_KIT_INSTRUCTIONS]: {
        component: __vue_component__$3,
        title: 'Follow kit instructions',
        footer: {
            label: 'Next',
        },
    },
    [WorkflowModalComponentName.ID_CARD]: {
        component: __vue_component__$4,
        title: 'CareSend ID',
        footer: {
            label: 'Done',
        },
    },
    [WorkflowModalComponentName.PATIENT_DOB]: {
        component: __vue_component__$5,
        title: 'Validate patient’s identity',
        footer: {
            label: 'Next',
            initDisabled: true,
        },
    },
    [WorkflowModalComponentName.SCANNER]: {
        component: __vue_component__$6,
        title: 'Unlock supplies',
        footer: {
            label: 'Done',
            initDisabled: true,
        },
        hideHeader: true,
    },
    [WorkflowModalComponentName.EMBED]: {
        component: __vue_component__$7,
        title: 'Embed',
        footer: {
            label: 'Next',
        },
    },
    [WorkflowModalComponentName.FILL_OUT_LABELS]: {
        component: __vue_component__$8,
        title: 'Fill out labels',
        footer: {
            label: 'Done',
            initDisabled: true,
        },
    },
    [WorkflowModalComponentName.PROCEDURE_CHARTING]: {
        component: __vue_component__$9,
        title: 'Chart procedure',
        footer: {
            label: 'Done',
            initDisabled: true,
        },
    },
    [WorkflowModalComponentName.PATIENT_CONSENT]: {
        component: __vue_component__$a,
        title: 'Patient consent',
        footer: {
            label: 'Done',
            initDisabled: true,
        },
    },
    [WorkflowModalComponentName.DROP_OFF_LAB_ORDER]: {
        component: __vue_component__$b,
        title: 'Present digital requisition form',
        footer: {
            label: 'Done',
        },
    },
    [WorkflowModalComponentName.PROCEDURE_INSTRUCTIONS]: {
        component: __vue_component__$c,
        title: 'Procedure instructions',
        footer: {
            label: 'Continue',
        },
    },
    [WorkflowModalComponentName.CONFIRM_DEPARTURE]: {
        component: __vue_component__$d,
        title: 'Departure confirmation',
        footer: {
            label: 'Drive',
            initHidden: true,
        },
    },
};
/**
 * List of components that can be opened by a footer button varient of type WorkflowItemModalButtonAction.OPEN_MODAL
 *
 * Please make sure that these components wrap around either an Alert or a Pane, and have props/emits
 * that allow us to handle their open status from the RouterModal.vue component.
 *
 * See code there for more details.
 */
const FooterActionOpenModalComponentRecord = {
    [FooterOpenModalComponentName.CHARTING_TUBE_LABELS]: {
        component: __vue_component__$e,
        title: 'Label tubes to proceed',
        footer: { label: 'Back to charting' },
    },
};

export { FooterActionOpenModalComponentRecord, WorkflowInlineComponentRecord, WorkflowModalComponentRecord };
